import { useEffect, useState } from 'react';
import axios from 'axios';
import { fetchShared, readCached } from '../utils/navDataCache';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

const cacheKey = (user) => `billing_summary:${user?.id || ''}:${user?.institute_id || ''}`;

/**
 * The institute's platform billing summary, shared by the sidebar, the due banner and the
 * Students page. Every page mounts its own DashboardLayout, so without the shared cache each
 * navigation asked for it two or three times. Only institute admins have billing.
 */
export default function useBillingSummary(user) {
  const enabled = user?.role === 'institute_admin';
  const key = cacheKey(user);
  const [summary, setSummary] = useState(() => (enabled ? readCached(key)?.data || null : null));

  useEffect(() => {
    if (!enabled) {
      setSummary(null);
      return undefined;
    }
    let active = true;
    const load = (force = false) => fetchShared(
      key,
      () => axios.get(`${API}/billing/summary`, { headers: { 'X-Skip-Global-Loader': '1' } }).then(({ data }) => data),
      { maxAge: 60000, force },
    ).then((data) => { if (active) setSummary(data); }).catch(() => { if (active) setSummary(null); });
    load();
    const refresh = () => load(true);
    window.addEventListener('coachhub-billing-changed', refresh);
    return () => {
      active = false;
      window.removeEventListener('coachhub-billing-changed', refresh);
    };
  }, [enabled, key]);

  return summary;
}

/** Call after a payment so the banner and sidebar show the new balance at once. */
export function notifyBillingChanged() {
  window.dispatchEvent(new Event('coachhub-billing-changed'));
}
